<template>
  <span v-html="header.template(item.item)"></span>
</template>
<script>
export default {
  props: ['header', 'item']
}
</script>
